import styled, {css} from 'styled-components';
import theme from './theme';

export const TableStyle = styled.div`
    width: 100%;
    padding: 0.5rem 1rem 1rem 1rem;
    > div {
        display: grid;
        grid-template-columns: repeat(auto-fit,minmax(4rem,auto));
        column-gap: 0.3rem;
        width: calc(100% - 2rem);
        padding: 0.5rem 0px;
    }
    .header {
        font-size: ${theme.fontSize.base};
        border-bottom: 1px solid ${theme.color.black[40]};
        span {
            display: flex;
            color: ${theme.color.black[40]};
            align-item: center;
            justify-content: center;
        }
    }
    .row {
        
        font-size: ${theme.fontSize.base};
        border-radius: 8px;
        span {
            display: flex;
            align-item: center;
            color: ${theme.color.black[80]};
        }
        &:hover {
            background: ${theme.color.black[10]};
            font-sieze: ${theme.fontSize.base};
            // font-weight: 500;
            box-shadow: ${theme.color.shadow};
        }
        transition: all 200ms ease-in-out, transform 400ms ease-in-out;
        > span:first-child {
            padding-left: 8px;
            // background: red;
        }
        > span:last-child {
            padding-right: 8px;
            // background: red;
        }
    }
`;

export const SearchBarStyle = styled.div`

    // width: calc(100% - 2rem);
    // height: 3rem;

    padding: 1rem 1rem;
    margin: 0.5rem 0rem;

    background: ${theme.color.primary.main};
    border-radius: 16px;

    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap;
    transition: ${theme.windowSize.drawerTransition};
`;

export const ErrorMsg = styled.span`
    font-size: 0.8rem;
    color: ${theme.color.secondary.red};
`;

export const Row = styled.div`
    display: flex;
    padding: 8px 0px;
    flex-wrap: wrap;
    align-items: center;
    gap: 18px;
`

export const TabText = styled.span`
    ${(props)=> props.selected === true ? activeSpan : nonActiveSpan};
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    transition : all 0.3s ease-in-out;
`;

const activeSpan = css`
    color: ${theme.color.black[80]};
    border-bottom: 1px solid ${theme.color.black[80]};
`;
const nonActiveSpan = css`
    color: ${theme.color.black[40]};
`;